import DateRangePickerML from './DateRangePickerML';

export default (props) => {
  return <DateRangePickerML {...props} />;
};
